import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../user.service';

@Component({
	selector: 'app-user-view',
	templateUrl: './user-view.component.html',
	styleUrls: ['./user-view.component.scss']
})
export class UserViewComponent implements OnInit {
	user: any
	private sub: any;

	constructor(
		public userService: UserService,
		private route: ActivatedRoute,
	) { }

	ngOnInit() {
		this.sub = this.route.params.subscribe(params => {
			this.userService.getUserWithUsername(params['username']).subscribe(user => {
				this.user = user
			})
		});
	}

	ngOnDestroy() {
		this.sub.unsubscribe();
	}

}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/user/user-view/user-view.component.ts